import React from 'react';
const AuthorizationContext = React.createContext(null);
const UserContext = React.createContext(null);
const RolesContext = React.createContext(null);
const DrawerContext = React.createContext(null);

export {UserContext, RolesContext, DrawerContext, AuthorizationContext};
